import React from "react";

export default function ProfessionalSuggestions() {
  const suggestions = []; // empty for now

  if (suggestions.length === 0) {
    return null; // intentionally hide section
  }

  return (
    <div className="suggest-box">
      {/* render suggestions */}
    </div>
  );
}
